import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import ExtractPDFPagesImageListScreen from "./ExtractPDFPagesImageListScreen";
import { BASE_URL } from "../Config";

function ExtractPDFPagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Extract PDF Pages Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/extract_pdf_pages", title: "Extract Pages From PDF" },
    data2: { link: "/extract_pdf_pages", title: "PDF Page Extractor" },
    data3: {
      link: "/extract_pdf_pages",
      title: "Extract PDF Pages Seperately",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Extract PDF pages online easily. Select and save specific pages from PDFs quickly with our fast, secure, and easy PDF page extractor tool."
      ></meta>
      <meta
        name="keywords"
        content="extract PDF pages, PDF page extractor, extract pages from PDF, select PDF pages, PDF editor online, PDF page tool, online PDF extractor, save PDF pages, PDF management tool, PDF document editor, extract PDF online, PDF page selection, extract specific PDF pages, PDF page saver, PDF editing tool"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <ExtractPDFPagesImageListScreen
          title={title}
        ></ExtractPDFPagesImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Extract PDF Pages website provides a fast, secure, and flexible solution to extract pages from PDF files both offline and online, making document management simple and efficient. Designed for students, professionals, and businesses, this powerful PDF page extractor allows you to select and extract specific pages from large PDF documents without affecting the original file. With offline functionality, all PDF page extraction is processed directly on your device, ensuring complete privacy and data security without uploading files to external servers. When internet access is available, users can also extract PDF pages online using a smooth, browser-based interface for instant results. Whether you need to extract PDF pages separately, split a PDF into individual pages, or save selected pages as a new document, this tool delivers accurate output while preserving original layout and quality. The platform supports extract PDF pages online free, allowing users to perform quick extractions without complex setup or subscriptions. Using advanced processing technology, the tool maintains text clarity, images, and formatting during extraction, ensuring professional-quality results. Compatible with desktop and mobile devices, this website helps users extract pages from PDF files efficiently for assignments, reports, legal documents, and presentations. If you are searching for the best PDF page extractor, extract PDF pages online free, extract PDF pages online, or a reliable way to extract PDF pages separately both offline and online, this platform offers a complete, user-friendly, and privacy-first solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Extract",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Extract PDF Pages"
            why_use={[
              {
                title: "Work with Only Required PDF Pages",
                description:
                  "Large PDF files often contain unnecessary content. Using a PDF page extractor helps you extract PDF pages and focus only on the information you need.",
              },
              {
                title: "Reduce PDF File Size Easily",
                description:
                  "By removing unwanted pages, you can significantly reduce document size. Tools that extract PDF pages online create smaller, optimized PDFs for easy sharing.",
              },
              {
                title: "Extract PDF Pages Separately",
                description:
                  "When individual pages are needed as standalone files, a reliable tool lets you extract PDF pages separately without affecting the original document.",
              },
              {
                title: "Easy Sharing and Emailing",
                description:
                  "Sharing selected pages is faster than sending entire documents. Using extract PDF pages online free tools makes emailing and messaging simple.",
              },
              {
                title: "Improve Document Organization",
                description:
                  "Extracting pages helps organize files more efficiently. A PDF page extractor makes it easy to split, rearrange, or archive important pages.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students and professionals often need to extract PDF pages online for assignments, reports, contracts, and presentations quickly and accurately.",
              },
              {
                title: "Preserve Original Quality and Layout",
                description:
                  "Modern extraction tools maintain text clarity, images, and formatting, ensuring extracted PDF pages remain professional and print-ready.",
              },
              {
                title: "Save Time in Document Workflows",
                description:
                  "Instead of recreating documents, a PDF page extractor allows instant extraction, speeding up everyday PDF management tasks.",
              },
              {
                title: "Work Offline or Online Anytime",
                description:
                  "Offline and online tools allow you to extract PDF pages securely without internet access or extract PDF pages online free when connected.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${6504000491}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default ExtractPDFPagesMain;
